"use client";

import { useEffect } from "react";
import { reportClientError } from "@/lib/error-report";
import { reloadOnceForChunkError, shouldAutoReloadForChunkError } from "@/lib/runtime-error-monitor";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[GlobalError]", error);
    reportClientError({
      message: error.message,
      digest: error.digest,
      kind: "global_error",
      pageUrl: typeof window !== "undefined" ? window.location.href : "unknown",
      userAgent: typeof navigator !== "undefined" ? navigator.userAgent : "unknown",
      stack: error.stack,
    });
    if (shouldAutoReloadForChunkError(error)) {
      reloadOnceForChunkError();
    }
  }, [error]);

  return (
    <html lang="zh-CN">
      <body>
        <div style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          padding: "2rem",
          fontFamily: "system-ui, -apple-system, sans-serif",
          textAlign: "center",
        }}>
          <h2 style={{ fontSize: "1.25rem", fontWeight: 600, marginBottom: "0.5rem" }}>
            出了点问题
          </h2>
          <p style={{ color: "#666", marginBottom: "1.5rem", fontSize: "0.875rem" }}>
            应用遇到了意外错误，请尝试刷新页面。
          </p>
          <button
            onClick={reset}
            style={{
              padding: "0.5rem 1.5rem",
              borderRadius: "0.375rem",
              border: "1px solid #ccc",
              background: "#fff",
              cursor: "pointer",
              fontSize: "0.875rem",
            }}
          >
            重新加载
          </button>
        </div>
      </body>
    </html>
  );
}
